import { z } from 'zod'
import { oc } from '@orpc/contract'
import { actorOverrideSchema, threadPathSchema } from './assistant-conversation.contract'

export const assistantSend = oc
  .route({ method: 'POST', path: '/v2/assistant/conversations/thread/send' })
  .input(
    z.object({
      threadPath: threadPathSchema,
      text: z.string().min(1),
      actor: actorOverrideSchema,
    }),
  )
  .output(
    z.discriminatedUnion('status', [
      z.object({ status: z.literal('sent'), turnId: z.string() }),
      z.object({ status: z.literal('already_streaming') }),
    ]),
  )
